// Connected apps (MCP connector) Analytics Events
const MCP_ANNOUNCEMENT_SHOWN = 'Mcp Announcement Shown';
const MCP_ANNOUNCEMENT_ACCEPTED = 'Mcp Announcement Accepted';
const MCP_ANNOUNCEMENT_DISMISSED = 'Mcp Announcement Dismissed';
const MCP_SETUP_URL_COPIED = 'Mcp Setup Url Copied';
const MCP_SETUP_GUIDE_OPENED = 'Mcp Setup Guide Opened';

export const CONNECTED_APPS_EVENTS = {
  MCP_ANNOUNCEMENT_SHOWN,
  MCP_ANNOUNCEMENT_ACCEPTED,
  MCP_ANNOUNCEMENT_DISMISSED,
  MCP_SETUP_URL_COPIED,
  MCP_SETUP_GUIDE_OPENED,
};
